import { getFragmentData, type FragmentType } from '@packages/gql/generated/shopping';
import { UseManufacturerTrackingFragmentFragmentDoc } from '@packages/gql/generated/shopping/UseManufacturerTrackingFragmentFragmentDoc';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinDisplayButton,
  GTMEventGlycerinDisplayOverlay,
} from '@packages/tracking/src/types/events';

/* GraphQL */ `
  fragment UseManufacturerTrackingFragment on Brand {
    name
  }
`;

export type Vendor = 'Loadbee';

export type UseManufacturerTrackingMethodsProps = {
  data: FragmentType<typeof UseManufacturerTrackingFragmentFragmentDoc> | null;
  vendor: Vendor;
};

const getCategoryValue = (data: UseManufacturerTrackingMethodsProps['data']) => {
  const unmaskedData = getFragmentData(UseManufacturerTrackingFragmentFragmentDoc, data);

  return unmaskedData ? `Herstellerinformationen ${unmaskedData.name}` : '';
};

export const useManufacturerTracking = () => {
  const dispatchTracking = useTracking();

  const trackGlycerinDisplayButton = ({ data, vendor }: UseManufacturerTrackingMethodsProps) => {
    dispatchTracking<GTMEventGlycerinDisplayButton>({
      event: 'DisplayButton',
      DisplayButtonData: {
        category: getCategoryValue(data),
        detail: vendor,
        label: 'Content-Products',
      },
    });
  };

  const trackGlycerinButtonClick = ({ data, vendor }: UseManufacturerTrackingMethodsProps) => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category: getCategoryValue(data),
        detail: vendor,
        label: 'Content-Products',
      },
    });
  };

  const trackGlycerinDisplayOverlay = ({ data, vendor }: UseManufacturerTrackingMethodsProps) => {
    dispatchTracking<GTMEventGlycerinDisplayOverlay>({
      event: 'DisplayOverlay',
      DisplayOverlayData: {
        category: getCategoryValue(data),
        detail: vendor,
        label: 'Content-Products',
      },
    });
  };

  return { trackGlycerinDisplayButton, trackGlycerinButtonClick, trackGlycerinDisplayOverlay };
};
